import React from "react";
import PropTypes from "prop-types";

import MaterialSpinner from "../../../ui/materialSpinner";
import {useProgressiveImage} from "../../../../misc/helperHooks";


const ShopFeatureImageGalleryItem = (props) => {

  const {galleryImage, galleryImageIndex, galleryImageClick} = props;

  const loaded = useProgressiveImage(galleryImage.url)

  return (
    <li className="shop-feature__gallery-item" key={galleryImage.url || "galleryImage" + galleryImageIndex}
        onClick={() => galleryImageClick(galleryImageIndex)}
        style={{backgroundImage: `url(${loaded ? galleryImage.url : null})`}}>
      {loaded ? null : <MaterialSpinner/>}
    </li>
  )
};

ShopFeatureImageGalleryItem.propTypes = {
  galleryImage: PropTypes.object.isRequired,
  galleryImageIndex: PropTypes.number.isRequired,
  galleryImageClick: PropTypes.func.isRequired,
}

export default ShopFeatureImageGalleryItem
